import { useEffect, useState } from 'react'
import EkomApi from '../api/EkomApi'
import { iMsg, iSubm } from '../types/msg.types'

export const useMsgDetail = (id: string, isSent: boolean, isSubms?: boolean) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [data, setData] = useState<iMsg | iSubm>()

  const fetchData = async () => {
    setError('')
    setLoading(true)
    try {
      const result = isSubms
        ? await EkomApi.getSubmissionDetail(id)
        : isSent
          ? await EkomApi.getMsgOutgoingDetail(id)
          : await EkomApi.getMsgIncomingDetail(id)

      if (!isSubms) {
        try {
          const msgReads = isSent
            ? await EkomApi.getMsgOutgoingReads(id)
            : await EkomApi.getMsgIncomingReads(id)

          if (msgReads.length) {
            result.readsCount = msgReads.length
          }
        } catch (e) {
          // zadne info o precteni, pak je neprectena
        }
      }
      setData(result)
    } catch (error: any) {
      setError('Nepodařilo se získat data.')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return { loading, error, data }
}
